import script from "./LoadingBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingBar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
